import { useState } from 'react';
import { CircleCheck, Info } from 'lucide-react';
import { Chip } from '@/ui/primitives';
import type { ClienteDetail } from '../schemas';

// Campos que entram no cálculo de completude do cadastro básico.
// CAF não entra — não é universal (depende da linha de crédito que o
// produtor pega, ex: PRONAF exige, outras não).
interface CampoCheck {
  key: keyof ClienteDetail;
  label: string;
}
const CAMPOS: CampoCheck[] = [
  { key: 'telefone', label: 'Telefone' },
  { key: 'email', label: 'Email' },
  { key: 'data_nascimento', label: 'Data de nascimento' },
  { key: 'rg', label: 'RG' },
  { key: 'profissao', label: 'Profissão' },
  { key: 'estado_civil', label: 'Estado civil' },
  { key: 'municipio', label: 'Município' },
  { key: 'endereco', label: 'Endereço' },
];

function isEmpty(v: unknown): boolean {
  return v == null || (typeof v === 'string' && v.trim() === '');
}

export function computeCompletude(cliente: ClienteDetail): {
  percent: number;
  missing: string[];
  filled: number;
  total: number;
} {
  const missing: string[] = [];
  for (const c of CAMPOS) {
    if (isEmpty(cliente[c.key])) missing.push(c.label);
  }
  const filled = CAMPOS.length - missing.length;
  return {
    percent: Math.round((filled / CAMPOS.length) * 100),
    missing,
    filled,
    total: CAMPOS.length,
  };
}

export function CompletudeIndicator({ cliente }: { cliente: ClienteDetail }) {
  const { percent, missing, filled, total } = computeCompletude(cliente);
  const tone =
    percent === 100 ? 'ok' : percent >= 70 ? 'info' : percent >= 40 ? 'warn' : 'danger';
  const [hover, setHover] = useState(false);

  return (
    <div
      className="relative inline-flex items-center"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Chip tone={tone} size="sm">
        {percent === 100 ? (
          <span className="inline-flex items-center gap-1">
            <CircleCheck size={11} strokeWidth={1.75} />
            Cadastro completo
          </span>
        ) : (
          <span className="inline-flex items-center gap-1">
            <Info size={11} strokeWidth={1.75} />
            Cadastro {percent}% ({filled}/{total})
          </span>
        )}
      </Chip>
      {hover && missing.length > 0 && (
        <div
          role="tooltip"
          className="absolute left-0 top-full mt-1.5 z-50 min-w-[200px] rounded-md border border-border bg-elevated px-3 py-2 shadow-[var(--shadow-over)]"
        >
          <div className="text-[0.7rem] font-semibold uppercase tracking-wide text-text-muted mb-1">
            Faltam preencher
          </div>
          <ul className="flex flex-col gap-0.5 text-[0.78rem] text-text">
            {missing.map((m) => (
              <li key={m} className="flex items-center gap-1.5">
                <span
                  className="w-1 h-1 rounded-full bg-[var(--danger)] shrink-0"
                  aria-hidden
                />
                {m}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
